import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters, {
	type standardToPremiumModalQuery,
} from './__generated__/standardToPremiumModalQuery.graphql';

type EntryPointParams = {
	cloudId: string;
	hamsProductKey: string;
};

export const entryPoint: EntryPoint<
	EntryPointComponent<
		{
			standardToPremiumModalQuery: standardToPremiumModalQuery;
		},
		Record<string, never>,
		{
			onClose: () => void;
		},
		Record<string, never>
	>,
	EntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_edition-awareness-standard-to-premium-modal" */ './standard-to-premium-modal'
			),
		{
			moduleId: 'edition-awareness-standard-to-premium-modal',
		},
	),
	getPreloadProps: ({ cloudId, hamsProductKey }: EntryPointParams) => ({
		entryPoints: {},
		extraProps: {},
		queries: {
			standardToPremiumModalQuery: {
				parameters,
				variables: {
					cloudId,
					hamsProductKey,
				},
			},
		},
	}),
});
